(ns app.front.ui.notes
  (:require [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.util :as uiu]
            [app.front.ui.visibility-title :as ui-visibility]
            [core.front.event :refer [<sub]]))


(def two-cols (uiu/wrap-in :div.flex.w-full.flex-wrap {} :div.mb-2.md:pr-2.md:w-1-2.w-full.leading-snug {}))
(def header :label.w-full.bx--label)


(defn note-block [title content]
  (when-not (empty? content)
    [:<>
     [header title]
     [:div.mb-6.leading-snug
      [ui-rt/editor-legacy {:initial-value content}]]]))


(defn internal-external-note [{:keys [tr internal external internal-title external-title]}]
  [(if (and (<sub [:session/authority-user?])
            internal
            external) two-cols :div.w-full)
   (when (<sub [:session/authority-user?])
     [note-block
      [ui-visibility/visibility-title
       {:visibility :internal
        :tr         tr}
       internal-title]
      internal])
   [note-block
    [ui-visibility/visibility-title
     {:visibility :public
      :tr         tr}
     external-title]
    external]])
